import React, { useEffect, useState } from "react";
import { fetchTraineesRegistrations } from "../../services/data";
import { cairoDate } from "../../utils/cairoDate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faArrowRight } from "@fortawesome/free-solid-svg-icons";
import { updateCheckTrainees } from "../../services/watoms/traineeRegistration";
import { ORGANIZATION_CITY_RELATION } from "../../constants/constants";
import EbdaEduNavbar from "components/navbars/EbdaEduNavbar";
import { useTheme } from "context/ThemeContext";
import { useLanguage } from "context/LanguageContext";

const EbdaEduWatomsTraineesRegistrations = () => {
    const { darkMode } = useTheme();
    const { language } = useLanguage();
    const [data, setData] = useState([]);
    const [registerCount, setRegisterCount] = useState(0);
    const [page, setPage] = useState("general");
    const [unfilteredData, setUnfilteredData] = useState([]);
    const [submitted, setSubmitted] = useState(false);
    const [numberSearch, setNumberSearch] = useState("");
    const [locationSearch, setLocationSearch] = useState("");

    const handleCheckboxChange = async (userId, checked) => {
        try {
            await updateCheckTrainees(Number(userId), checked);

            setSubmitted(prev => !prev);

            // Update unfiltered
            setUnfilteredData(users =>
                users.map(u =>
                    u.id === userId ? { ...u, is_new: !checked } : u
                )
            );

            // Update grouped
            setData(groups =>
                groups.map(group => ({
                    ...group,
                    items: group.items.map(u =>
                        u.id === userId ? { ...u, is_new: !checked } : u
                    )
                }))
            );

        } catch (error) {
            console.error("API error:", error);
        }
    };

    const togglePage = () => {
        if (page === "general") {
            setPage("detailed");
        } else {
            setPage("general");
        }
    }

    const uniqueCount = (arr) => {
        const seen = new Set(arr.map(item => item.id_number));
        return seen.size;
    };

    const removeDupById = (arr) => {
        const seen = new Set();
        return arr.filter(item => {
            if (seen.has(item.id_number)) return false;
            seen.add(item.id_number);
            return true;
        });
    };

    // Simulate fetch from backend
    useEffect(() => {
        async function fetchData() {
            try {
                const response = await fetchTraineesRegistrations();
                const cleaned = removeDupById(response);

                setUnfilteredData(cleaned);
                setRegisterCount(uniqueCount(cleaned));
                setUnfilteredData(cleaned);
                setRegisterCount(uniqueCount(cleaned));
                const grouped = Object.values(
                    cleaned.reduce((acc, item) => {
                        const normalizedKey =
                            item.certification === "حاصل علي شهادة جامعية" ||
                                item.certification === "طالب جامعي"
                                ? "جامعي"
                                : "غير جامعي";

                        const key = `${item.curriculum.code}|${item.org?.name || item.gov}|${normalizedKey}`;

                        if (!acc[key]) {
                            acc[key] = {
                                curriculum: item.curriculum.code,
                                org: item.org?.name || item.gov,
                                category: normalizedKey,
                                items: [],
                            };
                        }

                        acc[key].items.push(item);

                        return acc;
                    }, {})
                );

                grouped.sort((a, b) => {
                    // 1. Sort by organization name
                    const orgCompare = a.org.localeCompare(b.org);
                    if (orgCompare !== 0) return orgCompare;

                    // 2. If same org, sort by curriculum code
                    const curriculumCompare = a.curriculum.localeCompare(b.curriculum);
                    if (curriculumCompare !== 0) return curriculumCompare;

                    // 3. If same curriculum, sort by category ("جامعي" first)
                    if (a.category === b.category) return 0;
                    return a.category === "جامعي" ? -1 : 1;
                });

                // (Optional) ✅ Sort inside each items array if needed
                grouped.forEach(group => {
                    group.items.sort((a, b) => a.certification.localeCompare(b.certification));
                });
                setData(grouped);
            } catch (err) {
                console.error("Error fetching data:", err);
            }
        }
        fetchData();
    }, [submitted]);

    return (
        <div className={`min-h-screen max-w-screen flex flex-col md:gap-4 gap-52 items-center ${darkMode && 'bg-watomsBlue text-white'}`}>
            <EbdaEduNavbar />
            <div className={`shadow-lg rounded-2xl p-6 w-[95%] ${darkMode ? 'bg-blue-900' : 'bg-white'}`} dir={language ? "ltr" : "rtl"}>
                <div className="flex gap-4 items-center mb-4">
                    <h1 className="text-2xl font-bold">
                        {language ? "Trainees Information:" : "بيانات المتقدمين:"}
                    </h1>
                    <h1 className="text-xl font-bold">
                        ({language ? "count:" : "العدد:"} {registerCount})
                    </h1>
                    <button onClick={togglePage}><FontAwesomeIcon icon={language ? faArrowLeft : faArrowRight} /></button>
                    <h1 className="font-bold">{page}</h1>
                    <button onClick={togglePage}><FontAwesomeIcon icon={language ? faArrowRight : faArrowLeft} /></button>
                    {page !== "general" && <input
                        type="text"
                        placeholder={language ? "Search by WhatsApp..." : "البحث برقم الواتساب..."}
                        value={numberSearch}
                        onChange={(e) => setNumberSearch(e.target.value)}
                        className="border px-3 py-2 rounded-lg shadow-sm w-64"
                    />}
                    {page !== "general" && <input
                        type="text"
                        placeholder={language ? "Search by City or Center..." : "البحث بالمركز او المحافظة..."}
                        value={locationSearch}
                        onChange={(e) => setLocationSearch(e.target.value)}
                        className="border px-3 py-2 rounded-lg shadow-sm w-64"
                    />}
                </div>
                <div className="overflow-x-auto flex flex-col gap-6">
                    {page === "general" ?
                        <table className="w-full border border-gray-200 rounded-lg">
                            <thead className="bg-gray-200 text-gray-700">
                                {/* Table Header */}
                                <tr>
                                    <th className="py-2 px-4 border">#</th>
                                    <th className="py-2 px-4 border">{language ? "Date" : "التاريخ"}</th>
                                    <th className="py-2 px-4 border">{language ? "Time" : "التوقيت"}</th>
                                    <th className="py-2 px-4 border">{language ? "Full Name" : "اسم المتقدم"}</th>
                                    <th className="py-2 px-4 border">Whatsapp</th>
                                    <th className="py-2 px-4 border">{language ? "Phone" : "المحمول"}</th>
                                    <th className="py-2 px-4 border">{language ? "Center" : "المركز"}</th>
                                    <th className="py-2 px-4 border">{language ? "City" : "المحافظة"}</th>
                                    <th className="py-2 px-4 border">{language ? "Certification" : "الشهادة"}</th>
                                    <th className="py-2 px-4 border">{language ? "Course" : "التخصص"}</th>
                                </tr>
                            </thead>
                            <tbody>
                                {unfilteredData.length > 0 ? (
                                    unfilteredData.map((user, index) => (
                                        <tr
                                            key={index}
                                            className={`hover:bg-gray-50 transition duration-150 text-center text-black bg-white`}
                                        >
                                            <td className="py-2 px-4 border">{unfilteredData.length - index}</td>
                                            <td className="py-2 px-4 border">{cairoDate(user.createdAt).split(",")[0].trim()}</td>
                                            <td className="py-2 px-4 border">{cairoDate(user.createdAt).split(",")[1].trim()}</td>
                                            <td className="py-2 px-4 border">{user.first_name} {user.second_name} {user.third_name} {user.fourth_name}</td>
                                            <td className="py-2 px-4 border">{`+2${user.whatsapp}`}</td>
                                            <td className="py-2 px-4 border">{`+2${user.phone}`}</td>
                                            <td className="py-2 px-4 border">{user.org?.name || "لا يوجد"}</td>
                                            <td className="py-2 px-4 border">{ORGANIZATION_CITY_RELATION[user.vtc] || user.gov}</td>
                                            <td className="py-2 px-4 border">{user.certification}</td>
                                            <td className="py-2 px-4 border">{user.curriculum.code}</td>
                                        </tr>
                                    ))
                                ) : (
                                    <tr>
                                        <td colSpan="9" className="text-center py-4 text-gray-500">
                                            No data available
                                        </td>
                                    </tr>
                                )}
                            </tbody>
                        </table>
                        : data.map(group => {
                            const filteredItems = group.items.filter(user => {
                                const number = numberSearch.trim();
                                const location = locationSearch.trim();

                                return (
                                    user.whatsapp.toString().includes(number) &&
                                    (
                                        user.gov.toString().includes(location)
                                    )
                                );
                            });

                            // If after filtering, the group has ZERO items → return nothing
                            if (filteredItems.length === 0) return null;

                            return (
                                <table
                                    className="w-full border border-gray-200 rounded-lg"
                                    key={`${group.curriculum}-${group.org}-${group.category}`}
                                >
                                    <thead className="bg-gray-200 text-gray-700">
                                        <tr>
                                            <th className="py-2 px-4 border">{language ? "Check" : 'حالة'}</th>
                                            <th className="py-2 px-4 border">#</th>
                                            <th className="py-2 px-4 border">{language ? "City" : "محافظة"}</th>
                                            <th className="py-2 px-4 border">{language ? "Center" : "المركز"}</th>
                                            <th className="py-2 px-4 border">{language ? "Course" : "التخصص"}</th>
                                            <th className="py-2 px-4 border">{language ? "Certification" : "الشهادة"}</th>
                                            <th className="py-2 px-4 border">{language ? "Full Name" : "اسم المتقدم"}</th>
                                            <th className="py-2 px-4 border">Whatsapp</th>
                                            <th className="py-2 px-4 border">{language ? "Phone" : "المحمول"}</th>
                                            <th className="py-2 px-4 border">{language ? "Registered At" : "تاريخ التسجيل"}</th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {filteredItems.map((user, index) => (
                                            <tr
                                                key={user.id}
                                                className={`transition duration-150 text-center ${user.is_new
                                                    ? "bg-white hover:bg-gray-50 text-black"
                                                    : "bg-gray-400 hover:bg-gray-500 text-white"
                                                    }`}
                                            >
                                                <td className="py-2 px-4 border">
                                                    <input
                                                        type="checkbox"
                                                        checked={!user.is_new}
                                                        onChange={(e) =>
                                                            handleCheckboxChange(user.id, e.target.checked)
                                                        }
                                                    />
                                                </td>

                                                <td className="py-2 px-4 border">{index + 1}</td>
                                                <td className="py-2 px-4 border">{user.gov}</td>
                                                <td className="py-2 px-4 border">{user?.org?.name}</td>
                                                <td className="py-2 px-4 border">{user.curriculum.code}</td>
                                                <td className="py-2 px-4 border">{user.certification}</td>
                                                <td className="py-2 px-4 border">
                                                    {user.first_name} {user.second_name} {user.third_name} {user.fourth_name}
                                                </td>
                                                <td className="py-2 px-4 border">{`+2${user.whatsapp}`}</td>
                                                <td className="py-2 px-4 border">{`+2${user.phone}`}</td>
                                                <td className="py-2 px-4 border">
                                                    {cairoDate(user.createdAt).split(",")[0].trim()}
                                                </td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </table>
                            );
                        })}
                </div>
            </div>
        </div>
    );
}

export default EbdaEduWatomsTraineesRegistrations;